import { api } from "@/lib/api";

export const planningApi = {
  meta: () => api.get("/planning/meta").then((r) => r.data),
  stats: () => api.get("/planning/stats").then((r) => r.data),
  salesOrders: () => api.get("/planning/sales-orders").then((r) => r.data),
  jobs: (params) => api.get("/planning/jobs", { params }).then((r) => r.data),
  job: (id) => api.get(`/planning/jobs/${id}`).then((r) => r.data),
  createJob: (body) => api.post("/planning/jobs", body).then((r) => r.data),
  updateJob: (id, body) => api.put(`/planning/jobs/${id}`, body).then((r) => r.data),
  setStatus: (id, status, note) => api.patch(`/planning/jobs/${id}/status`, { status, note }).then((r) => r.data),
  machines: (stage) => api.get("/planning/machines", { params: { stage } }).then((r) => r.data),
  addMachine: (body) => api.post("/planning/machines", body).then((r) => r.data),
};

export const JOB_STATUS_STYLE = {
  Planning: "bg-slate-100 text-slate-700",
  "Ready for Production": "bg-blue-50 text-blue-700 border border-blue-200",
  Released: "bg-violet-50 text-violet-700 border border-violet-200",
  "In Production": "bg-indigo-50 text-indigo-700 border border-indigo-200",
  Completed: "bg-teal-50 text-teal-700 border border-teal-200",
  Closed: "bg-emerald-50 text-emerald-700 border border-emerald-200",
  Cancelled: "bg-rose-50 text-rose-700 border border-rose-200",
};

export const PRIORITY_STYLE = {
  Low: "bg-slate-100 text-slate-600",
  Normal: "bg-blue-50 text-blue-700",
  High: "bg-amber-50 text-amber-700",
  Urgent: "bg-rose-50 text-rose-700",
};
